import TaxBenefitCalculator from '../components/TaxBenefitCalculator';
import { defineCalculator } from './defineCalculator';

defineCalculator('scl-tax-benefit-calculator', TaxBenefitCalculator);
